exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".search-title{padding-bottom:5px;padding-left:0!important}.no-globalIds{font-size:18px;text-align:center;color:#bbb;letter-spacing:5px;height:305px;padding:75pt}.ant-popover-placement-top .ant-popover-content .ant-popover-inner i{display:none!important}.ant-popover-placement-top .ant-popover-inner{padding:10px!important}.ant-popover-placement-top .ant-popover-message{font-size:14px!important;padding:5px!important}.ant-popover-placement-top .ant-popover-buttons .ant-btn-ghost{margin-right:10px!important}.ant-popover-placement-top .ant-popover-buttons button{margin-left:0!important}.text-right{text-align:right}.ant-table tr:hover,.down-table .ant-table tr.ant-table-row-hover{background:#fff!important}.close-modal{position:absolute;top:0;right:5px;font-size:1pc;cursor:pointer}.ant-confirm{top:50%!important;margin-top:-90px!important}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/app/modules/collection/components/style.css
 ** module id = 1727
 ** module chunks = 0
 **/